// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/panel-left-dashed.js';

import { paths } from '../generated/panel-left-dashed';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('panel-left-dashed', Original, paths);
